import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Set Pages
import { NewOrdersComponent } from './new-orders/new-orders.component';
import { OrderInProgressComponent } from './order-progress/order-in-progress/order-in-progress.component';
import { WritersProgressComponent } from './order-progress/writers-progress/writers-progress.component';
import { WritersSubjectsComponent } from './order-progress/writers-subjects/writers-subjects.component';
import { SubmissionsComponent } from './submissions-folder/submissions/submissions.component';
import { ChargebacksComponent } from './submissions-folder/chargebacks/chargebacks.component';
import { NewRevisionsComponent } from './revisions/new-revisions/new-revisions.component';
import { AllRevisionsComponent } from './revisions/all-revisions/all-revisions.component';
import { RevisionsInProgressComponent } from './revisions/revisions-in-progress/revisions-in-progress.component';
import { InvalidRevisionsComponent } from './revisions/invalid-revisions/invalid-revisions.component';
import { RevisedWorkComponent } from './revisions/revised-work/revised-work.component';
import { ProgressRequestsComponent } from './progress-requests/progress-requests.component';
import { CwhpComponent } from './cwhp/cwhp.component';

const routes: Routes = [
  { path: 'new-orders',                           component: NewOrdersComponent            },
  { path: 'order-in-progress',                    component: OrderInProgressComponent      },
  { path: 'writers-progress',                     component: WritersProgressComponent      },
  { path: 'writers-subjects',                     component: WritersSubjectsComponent      },
  { path: 'submissions',                          component: SubmissionsComponent          },
  { path: 'chargeback',                           component: ChargebacksComponent          },
  { path: 'new-revisions',                        component: NewRevisionsComponent         },
  { path: 'all-revisions',                        component: AllRevisionsComponent         },
  { path: 'revisions-in-progress',                component: RevisionsInProgressComponent  },
  { path: 'invalid-revisions',                    component: InvalidRevisionsComponent     },
  { path: 'revised-work',                         component: RevisedWorkComponent          },
  { path: 'progress-requests',                    component: ProgressRequestsComponent     },
  { path: 'cwhp',                                 component: CwhpComponent                 },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupportRoutingModule { }
